
import { Box, Button, Grid, Hidden, MenuItem, Popover, Stack, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Modal from '../../components/Modal'
import { config_path, portalCfg } from '../../router/config.path'
import PublicPage from '../PublicPage'
import { cache } from '../../utils/cache'
import { BackIcon, FacebookFillIcon } from '../../components/IconComponent'
import FacebookLogin from 'react-facebook-login';
import InitiatePage from '../InitiatePage'
import { GetIconColor } from '../../theme/main_style'

export default function LoginWithFBView(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { palette, spacing } = useTheme();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const appConfig = cache.getAppConfig();
    const app_id = appConfig && appConfig.authentication&& appConfig.authentication.facebook ? appConfig.authentication.facebook.app_id : null;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onBack = ()=>{
        navigate(config_path.login_register);
    }

    let optionsColour = null;
    if (palette.secondary.background.startsWith('#fff') || palette.secondary.background.startsWith('#000') ) 
    {
        optionsColour = palette.primary.main;
    }
    else if(palette.primary.main === palette.secondary.background)
    {
        optionsColour = '#ffffff'
    }
    else{
        optionsColour = palette.primary.main;
    }
    const renderContent = () => {
        return (
            <>
                <Hidden mdUp>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:16,left:10 }} >
                        <BackIcon color={optionsColour}/>
                    </Stack>
                </Hidden>
                <Hidden mdDown>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:20,left:10 }} >
                        <BackIcon color={GetIconColor().primary}/>
                    </Stack>
                </Hidden>
                <Box
                    sx={{
                        position: {xs:'absolute', md: 'inherit'},
                        bottom: {xs:'0px', md: undefined},
                        backgroundColor: palette.background.paper,
                        borderRadius: '20px 20px 0px 0px',
                        p: 3, 
                        color: 'white', 
                        width: '100%',
                    }}>
                    <Grid item xs={12}>
                        <Form
                            onSubmit={props.onSubmit}
                            render={({ handleSubmit }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid item xs={12}>
                                        <Grid item xs={12} container alignItems={'center'}>
                                            <Grid item xs={12} paddingTop={1} textAlign={'center'}>
                                                <Box width={'100%'} key={'btn_login_facebook'} id={'btn_login_facebook'} flexDirection={'row'} component={Button}                                           justifyContent={'center'} alignItems='center'
                                                    onClick={() => props.handleFacebookCallback()}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        border: '1px solid ' + palette.primary.main,
                                                        borderRadius: 32,
                                                        padding: spacing(1, 2),
                                                    }}
                                                    startIcon={<FacebookFillIcon color={"rgb(24, 119, 242)"}/>}
                                                >
                                                <Typography variant='subtitle2' color={palette.primary.main}>{t('btn_login_facebook')}</Typography>
                                                </Box>
                                            </Grid>
                                            {/*<Grid item xs={12} marginY={3}>
                                                <Button id='loginPhone/btnSubmit' fullWidth size="large" variant='contained' onClick={handleSubmit} type='submit'>{t('btn_login')}</Button>
                            </Grid>*/}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        />
                    </Grid>
                </Box>
        </>
    )}

    return (
        <>
            <Hidden mdUp>
                <InitiatePage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </InitiatePage>
            </Hidden>

            <Hidden mdDown>
                <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </PublicPage>
            </Hidden>
        </>
        
    )
}
